import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './index.css';

const PublicSiteNavigator = (props: any) => {
    const navigate = useNavigate();

    const goToPublicSite = () => {
        navigate('/public');
    };

    return (
        <div>
            {props.projectPublicEnabled && <Button className="public-site-button" onClick={goToPublicSite}>
                Public Site
            </Button>}
        </div>
    );
};

export default PublicSiteNavigator;
